import { QueryClient } from "@tanstack/react-query";

// Single app-wide QueryClient for server-state data fetched via TanStack Query
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
